import { useMutation } from "@tanstack/react-query";
import {
  CreateNotificationParams,
  createNotification,
} from "supabase/notifications";

export const useCreateNotification = () => {
  const mutation = useMutation({
    mutationFn: (notification: CreateNotificationParams) => {
      return createNotification(notification);
    },
  });

  return mutation;
};
